import * as React from 'react';
export var AlertContext = React.createContext(null);